<template>
    <div :style="getStyle">
        <label v-if="isUploadFile" class="btn btn-sm btn-info" v-popover:tooltip="t(getTitle)">
            {{ t(getName) }}
            <input
                type="file" id="file" style="display: none;" ref="file" @change="onClickUploadFile"/>
        </label>
        <button v-else
            class="btn btn-sm btn-confirm"
            :style="{'background-color': getBackgroundColor }"
            :disabled="!getActive"
            :class="!getActive ? 'mark-disabled' : ''"
            v-popover:tooltip="t(getTitle)"
            @click.prevent="onClick">
            {{ t(getName) }}
        </button>
    </div>
</template>

<script>

import ValueChecker from "../../services/ValueChecker";

export default
{
    components: {},
    props: {
        config: {
            type: Object,
            default: function() {
                return {
                    backgroundColor: '',
                    title: '',
                    active: true,
                    hideWhenClick: false,
                    style: null
                }
            }
        },
        emitEvents: {
            type: Object,
        },
        eventBus: {
            type: Object,
        },
        routeName: {
            type: String
        },
        row: {
            type: Object,
        },
        state: {
            type: Object,
        },
        rowIndex: {
            type: Number
        },
    },
    data() {
        return {
            active: true,
            internalRow: {},
            internalClickEvent: [],
        };
    },
    computed: {
        getStyle() {
            return this.config.style || {margin: "1px", float: "left"};
        },
        getActive() {
            return this.active;
        },
        getBackgroundColor() {
            return this.config.backgroundColor;
        },
        getName() {
            return this.config.name;
        },
        getTitle() {
            return this.config.title;
        },
        isUploadFile() {
            return this.config.uploadFile;
        },
        isHideWhenClick() {
            return this.config.hideWhenClick;
        },
    },
    mounted() {
        this.mountEvents();
        this.active = this.config.active;
        this.internalRow = this.row || {};
    },
    beforeDestroy() {
        let eventManagerService = this.eventBus.getEventManager();
        eventManagerService.unbindEvents(this.defaultBindEvents());
    },
    methods: {
        createContext() {
            let context = {};

            if (!ValueChecker.isUndefinedOrNull(this.state)) {
                context = Object.assign(context, {state: this.state});
            }

            if (!ValueChecker.isUndefinedOrNull(this.rowIndex)) {
                context = Object.assign(context, {rowIndex: this.rowIndex});
            }

            if (!ValueChecker.isUndefinedOrNull(this.row)) {
                context = Object.assign(context, {row: this.row});
            }

            if (!ValueChecker.isUndefinedOrNull(this.internalRow)) {
                context = Object.assign(context, {formData: this.internalRow});
            }

            return context;
        },
        defaultBindEvents() {
            let componentIndex = this.getComponentIndex();

            return [{
                name: 'showComponent',
                componentIndex: componentIndex,
            },{
                name: 'hideComponent',
                componentIndex: componentIndex,
            }];
        },
        getComponentIndex() {
            let componentIndex = `${this.config.index}`;

            if (!ValueChecker.isUndefinedOrNull(this.rowIndex)) {
                componentIndex += `-${this.rowIndex}`;
            }

            return componentIndex;
        },
        hideComponent(q,w,e) {
            this.active = false;
        },
        mountEvents() {
            this.internalClickEvent = this.emitEvents['click'] || [];
            let eventManagerService = this.eventBus.getEventManager();
            let componentIndex = this.getComponentIndex();

            this.internalClickEvent.push({
                type: 'frontend',
                config: {
                    eventName: `${componentIndex}:showComponent`,
                }
            });
            eventManagerService.bindEvents(this.defaultBindEvents(), this);
        },
        onClickUploadFile() {
            let file = this.$refs.file.files[0];
            let formData = new FormData();
            formData.append('file', file);
            this.internalRow = formData;
            this.$refs.file.value = null;
            this.onClick();
        },
        onClick() {
            let stack = [this.createContext()];

            if (this.isHideWhenClick) {
                this.hideComponent();
            }

            let eventManagerService = this.eventBus.getEventManager();
            eventManagerService.emitEvents(this.internalClickEvent, stack);
        },
        showComponent(q,w,e) {
            this.active = true;
        },
    },
}
</script>

<style lang="sass" scoped>
    .mark-disabled {
        opacity: 0.4!important;
    }
</style>



// WEBPACK FOOTER //
// ActionComponent.vue?b5b86618